/** Deep-merge plain objects; arrays and primitives from `override` replace. */
export function mergeDeep<T extends Record<string, unknown>>(
  base: T,
  override: Partial<Record<keyof T, unknown>>,
): T {
  const out = { ...base } as T;
  for (const key of Object.keys(override) as (keyof T)[]) {
    const ov = override[key];
    if (ov === undefined) continue;
    const bv = base[key];
    if (
      bv !== null &&
      typeof bv === "object" &&
      !Array.isArray(bv) &&
      ov !== null &&
      typeof ov === "object" &&
      !Array.isArray(ov)
    ) {
      out[key] = mergeDeep(
        bv as Record<string, unknown>,
        ov as Record<string, unknown>,
      ) as T[keyof T];
    } else {
      out[key] = ov as T[keyof T];
    }
  }
  return out;
}
